function loadMoreProducts() {
  var $productsOnPage = $('.products-on-page');
  var nextUrl = $productsOnPage.attr('data-next-url');
  var $loadMoreBtn = $('.load-more_btn');
  var $loadMoreSpinner = $('.load-more_spinner');
  var $loadMoreWrap = $('.load-more');

  if (!$productsOnPage.length || !nextUrl) {
    $loadMoreWrap.hide();
    return;
  }

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    beforeSend: function () {
      $loadMoreBtn.hide();
      $loadMoreSpinner.show();
    }
  }).done(function (nextPage) {
    var $nextPage = $('<div>').html(nextPage);
    var $newProducts = $nextPage.find('.products-on-page').first();
    var newUrl = $newProducts.attr('data-next-url');

    $loadMoreSpinner.hide();

    if ($newProducts.length) {
      var $items = $newProducts.find('.product-item');
      $productsOnPage.append($items);
    }

    if (newUrl) {
      $productsOnPage.attr('data-next-url', newUrl);
      $loadMoreBtn.show();
    } else {
      $productsOnPage.removeAttr('data-next-url');
      $loadMoreWrap.hide();
    }
  }).fail(function () {
    $loadMoreSpinner.hide();
    $loadMoreBtn.show();
  });
}